import { render } from "./PersonalAuthorization.vue?vue&type=template&id=5cf7e5dc"
import script from "./PersonalAuthorization.vue?vue&type=script&lang=js"
export * from "./PersonalAuthorization.vue?vue&type=script&lang=js"

import "./PersonalAuthorization.vue?vue&type=style&index=0&id=5cf7e5dc&lang=css"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__